import apiClient from '@/utils/request'
import { IMediaKitResponse } from '@/apps/traforama/interfaces/mediaKits'

export const fetchItem = async (id: string): Promise<IMediaKitResponse> => {
  const response = await apiClient.get<IMediaKitResponse>(`/media_kits/${id}`)
  return response.data
}
